var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{style:(_vm.margins),attrs:{"id":"margins"}},[_c('b-col',{attrs:{"md":"12"}},[_c('div',{style:(_vm.separator),attrs:{"id":"separator"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }